import { apiRequest, buildQuery } from './client';

const id = (value) => encodeURIComponent(value);

export const adhkarPacksApi = {
  browse: (options) => apiRequest(`/api/v1/adhkar-packs${buildQuery(options)}`),
  get: (packId) => apiRequest(`/api/v1/adhkar-packs/${id(packId)}`),
  mine: () => apiRequest('/api/v1/me/adhkar-packs'),
  create: (body) => apiRequest('/api/v1/me/adhkar-packs', { method: 'POST', body }),
  updateMeta: (packId, body) => apiRequest(`/api/v1/me/adhkar-packs/${id(packId)}/meta`, { method: 'PUT', body }),
  updateItems: (packId, items) => apiRequest(`/api/v1/me/adhkar-packs/${id(packId)}/items`, { method: 'PUT', body: { items } }),
  publish: (packId, changelog) => apiRequest(`/api/v1/me/adhkar-packs/${id(packId)}/publish`, { method: 'POST', body: { changelog } }),
  unpublish: (packId) => apiRequest(`/api/v1/me/adhkar-packs/${id(packId)}/unpublish`, { method: 'POST' }),
  installed: () => apiRequest('/api/v1/me/adhkar-packs/installed'),
  install: (packId) => apiRequest(`/api/v1/me/adhkar-packs/${id(packId)}/install`, { method: 'POST' }),
  uninstall: (packId) => apiRequest(`/api/v1/me/adhkar-packs/${id(packId)}/install`, { method: 'DELETE' }),
  activate: (period, packId) => apiRequest(`/api/v1/me/adhkar/preferences/${id(period)}/active-pack`, { method: 'PUT', body: { packId } }),
  bookmarks: () => apiRequest('/api/v1/me/adhkar-packs/bookmarks'),
  bookmark: (packId, bookmarked) => apiRequest(`/api/v1/me/adhkar-packs/${id(packId)}/bookmark`, { method: 'PUT', body: { bookmarked } }),
  ratings: (packId) => apiRequest(`/api/v1/adhkar-packs/${id(packId)}/ratings`),
  myRating: (packId) => apiRequest(`/api/v1/me/adhkar-packs/${id(packId)}/rating`),
  rate: (packId, stars, text) => apiRequest(`/api/v1/me/adhkar-packs/${id(packId)}/rating`, { method: 'PUT', body: { stars, text } }),
  moderate: (packId, action, note = '') => apiRequest(`/api/v1/admin/adhkar-packs/${id(packId)}/moderation`, { method: 'PUT', body: { action, note } }),
  setCreationBan: (userId, banned) => apiRequest(`/api/v1/admin/adhkar-packs/users/${id(userId)}/creation-ban`, { method: 'PUT', body: { banned } }),
};
